import { Button } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

function Page2() {
    const navigate = useNavigate();

    return (
        <Button onClick={() => navigate(-1)}>BackButton</Button>
    )
}

export default Page2